import React, { useEffect, Suspense } from 'react';
import MainTemplate from 'templates/MainTemplate';
// ROUTER
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { routes } from 'routes';
import AppRedirect from 'routes/Redirect';
import { ScrollToTop } from 'functions/scrollToTop';
// REDUX
import useInit from 'useHandlers/useInit';
import { connect, useDispatch } from 'react-redux';
import { operationFetchGlobalBanners, operationFetchBillboards } from 'redux/operations/Banners';
// BOUNDARY
import ErrorInit from 'boundary/ErrorInit';
// COMPONETS
import Loader from 'components/atoms/Loader/Loader';
// ASETES:
import 'assets/fonts/fontawesome';
import 'assets/sass/theme.scss';
import 'assets/js/bootstrap';
// VIEWS
const Articles = React.lazy(() => import('views/Articles'));
const Article = React.lazy(() => import('views/Article'));
const Rankings = React.lazy(() => import('views/Rankings'));
const Ranking = React.lazy(() => import('views/Ranking'));
const Methodology = React.lazy(() => import('views/Methodology'));
const QualityMark = React.lazy(() => import('views/QualityMark'));
const Gallery = React.lazy(() => import('views/Gallery'));

const App = ({ articles, hashBanners, banners, billboards, name }) => {
	const [{ isLoading, isError, error }, fetchInit] = useInit();

	const dispatch = useDispatch();

	useEffect(() => {
		fetchInit();
	}, []);

	useEffect(() => {
		if (hashBanners) {
			if (!billboards) {
				dispatch(operationFetchBillboards(hashBanners.billboards));
			}
			if (!banners) {
				dispatch(operationFetchGlobalBanners(hashBanners.global));
			}
		}
	}, [hashBanners]);

	return (
		<Router>
			<ScrollToTop />
			{isLoading && <Loader />}
			{name && (
				<MainTemplate>
					<main>
						<Suspense fallback={<Loader />}>
							<Switch>
								<Route exact path={routes.home} component={AppRedirect} />
								<Route exact path={routes.articles} component={Articles} />
								<Route exact path={[routes.article, routes.methodology]} component={Article} />
								<Route exact path={routes.rankings} component={Rankings} />
								<Route exact path={routes.ranking} component={Ranking} />
								<Route exact path={routes.methodologies} component={Methodology} />
								<Route exact path={routes.qualityMark} component={QualityMark} />
								<Route exact path={routes.gallery} component={Gallery} />
								<Route
									exact
									path={routes.rankingJury}
									component={() => <Article propSlug={articles['ranking-jury'] ?? 'notHash'} />}
								/>
								{/* <Route component={AppRedirect} /> */}
							</Switch>
						</Suspense>
					</main>
				</MainTemplate>
			)}
			{isError && <ErrorInit error={{ message: error }} />}
		</Router>
	);
};

const mapStateToProps = ({ initial, banners }) => ({
	hashBanners: initial.banners,
	articles: initial.articles,
	name: initial.name,
	banners: banners.global,
	billboards: banners.billboards,
});

export default connect(mapStateToProps)(App);
